/**
 * @enum {string}
 */
import { StreamType } from '../../../api/models/Shared.types';
import {
  IChannelV5,
  IProgramV5,
  IProperty,
  IScheduleV5,
  ISeasonV5,
  ISeriesV5,
  IStreamAssetResponseV2,
} from '../../../api/models/AndromeTV.types';
import { Recording } from '../../../api/user/RecordingApi.types';
import { Bookmark } from '../logicHandlers/Bookmark';
import { addProperty } from '../../../api/analytics/AnalyticsUtil';
import { PropertyKeys } from '../../../api/analytics/ClientEvents';
import { Log } from '@lightningjs/sdk';

export const StreamInfoType = {
  VOD: 'VOD',
  LINEAR: 'LINEAR',
  REPLAY: 'REPLAY',
  NPVR: 'NPVR',
};

/**
 * @enum {number}
 */
export const StartPositionType = {
  START: 1,
  BOOKMARK: 2,
  LIVE: 3,
};

export interface EpgEvent {
  season?: ISeasonV5;
  channel: IChannelV5;
  program?: IProgramV5;
  series?: ISeriesV5;
  schedule?: IScheduleV5;
  recording?: Recording;
}

export class StreamInfo {
  public currentAsset?: IStreamAssetResponseV2;
  public bookmark?: Bookmark;

  get isAdult(): boolean | undefined {
    return undefined;
  }

  get assetId(): string | undefined {
    return undefined;
  }

  get resourceId(): string | undefined {
    return undefined;
  }

  get type(): string | undefined {
    return undefined;
  }

  get vodStreamId(): string | undefined {
    return undefined;
  }

  get titleText(): string {
    return '';
  }

  get metaInfo(): string {
    return '';
  }

  get channelName(): string {
    return '';
  }

  /**
   * @returns {string}
   */
  get streamType(): StreamType | undefined {
    return undefined;
  }

  get quoteId(): string | undefined {
    return undefined;
  }

  get startPositionTime(): number | undefined {
    return 0;
  }

  get startOffset(): number {
    return 0;
  }

  get allowSeek(): boolean {
    return true;
  }

  get canAutoPlay(): boolean {
    return false;
  }

  get resumeFromLive(): boolean {
    return false;
  }

  get channel(): IChannelV5 | undefined {
    return undefined;
  }

  get schedule(): IScheduleV5 | undefined {
    return undefined;
  }

  get episode(): number | undefined {
    return 0;
  }

  get season(): number | undefined {
    return 0;
  }

  convertPlayTimes(pos: number, duration: number, _isLive = false): PlayerTimes {
    return {
      position: pos,
      duration: duration,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  updateBookmark(_position: number, _duration: number): boolean {
    return true;
  }

  generateAnalyticsProperties(excluded: string[]): IProperty[] {
    const properties: IProperty[] = [];
    addProperty(PropertyKeys.id, this.assetId, excluded, properties);
    addProperty(PropertyKeys.name, this.titleText, excluded, properties);
    addProperty(PropertyKeys.vodStreamId, this.vodStreamId, excluded, properties);
    addProperty(PropertyKeys.streamType, this.streamType, excluded, properties);
    addProperty(PropertyKeys.episode, this.episode, excluded, properties);
    addProperty(PropertyKeys.season, this.season, excluded, properties);
    return properties;
  }

  updateStartPositionType(type: number) {
    Log.warn(`Cannot update start position type ${type} for stream type ${this.type}`);
  }
}

export interface PlayerTimes {
  position: number;
  duration: number;
}
